import { CollapsibleContainerRef } from "mt-components/CollapsibleContainer/CollapsibleContainer";
import { MutableRefObject, useCallback } from "react";
import {
  BsChatSquareHeart,
  BsFileEarmarkText,
  BsImages,
  BsLightningCharge,
  BsPinMapFill,
  BsQuestionCircle,
} from "react-icons/bs";
import useWindowSize from "../../../../../utils/useWindowSize";
import { scrollToCollapsibleContainer } from "../../helpers";
import styles from "./ProductNavigation.module.css";

interface ProductDetailNavProps {
  setGalleryOpen: Function;
  navigationRef: MutableRefObject<HTMLDivElement>;
  reviewsRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  summaryRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  faqsRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  highlightsRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  locationRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>;
  hasFAQ?: boolean;
}

export default function ProductNavigationNew({
  faqsRef,
  hasFAQ,
  highlightsRef,
  locationRef,
  navigationRef,
  reviewsRef,
  setGalleryOpen,
  summaryRef,
}: ProductDetailNavProps) {
  const { isMobile } = useWindowSize();

  const scrollTo = useCallback(
    (
      containerRef: MutableRefObject<CollapsibleContainerRef | HTMLDivElement>,
    ) => scrollToCollapsibleContainer(containerRef, navigationRef, isMobile),
    [isMobile, navigationRef],
  );

  return (
    <div className={styles["ProductDetailJumpers"]} ref={navigationRef}>
      <div className="AppLayout">
        <ul>
          <li onClick={() => setGalleryOpen(true)}>
            <span>
              <BsImages /> Photos
            </span>
          </li>
          <li onClick={() => scrollTo(summaryRef)}>
            <span>
              <BsFileEarmarkText /> Summary
            </span>
          </li>
          <li onClick={() => scrollTo(highlightsRef)}>
            <span>
              <BsLightningCharge /> Highlights
            </span>
          </li>
          <li onClick={() => scrollTo(locationRef)}>
            <span>
              <BsPinMapFill /> Meeting Point
            </span>
          </li>
          {hasFAQ && (
            <li onClick={() => scrollTo(faqsRef)}>
              <span>
                <BsQuestionCircle /> FAQs
              </span>
            </li>
          )}
          {reviewsRef !== null ? (
            <li onClick={() => scrollTo(reviewsRef)}>
              <span>
                <BsChatSquareHeart /> Reviews
              </span>
            </li>
          ) : null}
        </ul>
      </div>
    </div>
  );
}
